export default "__VITE_ASSET__DQ5Kfiw$__"